import React, {useEffect, useRef, useState} from 'react'
import {useParams} from "react-router-dom";
import {get, post,deleteApi} from "../../../../Network/Axios";
import {Button, Input, KeyValue, Modal, TOAST,Switch} from "../../../../../retro";

export default function User() {
    
    let saas = window.location.href.includes('cockpit.dice.tech') || window.location.href.includes('localhost');
    const {id} = useParams();
    const ID = useRef();
    const EP = useRef();
    const CERT = useRef();
    const PW = useRef(),ENTITY=useRef(),DOMAIN=useRef();
    const [config,setConfig] = useState({})
    const [entityConfig,setEntityConfig] =useState({});
    const [ssoConfig,setSsoConfig] = useState({});
    const [modal,setModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [entityEnable,setEntityEnable] = useState(false);
    const [domainEnable,setDomainEnable] = useState(false);
    const load = id => {
        get(`/clients/saml/${id}`,(e,r)=>{
            if(r){
                setConfig(r.ssoConfig)
                setEntityConfig(r.entitySsoConfig);
                setSsoConfig(r.multiDomainSsoConfig);
            }
        });
    }
    const toggle = id => {
        if(!config.enabled){
            setModal(true)
        }else{
            post(`/clients/saml/${id}/toggle`,{},(e,r)=>{
                if(r){
                    load(id)
                }
            });
        }
    }
    useEffect(()=>{
        load(id)
    },[id])


    let mapItemSso = (item,index) => {
        let mItem = ssoConfig[item]
        return(
            <div key={index} className='mt4 border-bottom flex horizontally'>
                <div className='flex-1'> 
                     <p className="text text-light">
                        Domain {item}
                     </p>
                    <p className="">
                        {config.endPoint}
                    </p>
                    <KeyValue title="Id" value={mItem.id} margin="mt1"/>
                    <KeyValue title="Cert" value={mItem.cert}/>
                    <div className="flex" style={{gap: '8px', marginBottom: '8px'}}>
                        <p 
                            style={{
                                color: '#dc3545',
                                cursor: 'pointer',
                                margin: 0,
                                padding: 0
                            }} 
                            onClick={()=>{
                                deleteApi(`clients/saml/removeSso/${id}?domain=${item}`,(e,r)=>{
                                    load(id);
                                    TOAST.success("Domain Removed Successfully")
                                })
                            }}
                        >
                            Delete
                        </p>
                        <p 
                            style={{
                                color: '#007bff',
                                cursor: 'pointer',
                                margin: 0,
                                padding: 0
                            }} 
                            onClick={()=>{
                                setSelectedEntity({...mItem, domain: item});
                                setEditModal(true);
                            }}
                        >
                            Edit
                        </p>
                    </div>
                </div>
                <div>
                <Switch
                    onChange={() => {
                        post(`/clients/saml/${id}/toggle`,{domain:item},(e,r)=>{
                            if(r){
                                load(id)
                            }
                        });
                    }}
                    state={mItem.enabled}
                />
                </div>
               
            </div>
        )
    }


    let mapItem = (item,index) => {
        let mItem = entityConfig[item]
        console.log(item);
        return(
            <div key={index} className='mt4 border-bottom flex horizontally'>
                <div className='flex-1'> 
                     <p className="text text-light">
                        Entity {item}
                     </p>
                    <p className="">
                        {config.endPoint}
                    </p>
                    <KeyValue title="Id" value={mItem.id} margin="mt1"/>
                    <KeyValue title="Cert" value={mItem.cert}/>
                    <p  style={{width:100,textAlign:'left'}} className="btn-link-danger btn mg0 pd0 mb2" onClick={()=>{
						deleteApi(`clients/saml/removeSso/${id}?entity=${item}`,(e,r)=>{
                            load(id);
                            TOAST.success("Entity Removed Successfully")
                        })
					}}>
						Delete
					</p>
                    <p>
                        Edit
                    </p>
                </div>
                
                
                <div>
                <Switch
                    onChange={() => {
                        post(`/clients/saml/${id}/toggle`,{entity:item},(e,r)=>{
                            if(r){
                                load(id)
                            }
                        });
                    }}
                    state={mItem.enabled}
                />
                </div>
               
            </div>
        )
    }

    return(
        <>
            {
                modal && <Modal title="Sso Config" description="Sso configuration" onClose={()=>{setModal(false)}}>
                    {
                    saas &&
                    <>
                       <div className='flex'>
                            <div className='flex-1'>
                                Enable Entity
                            </div>
                            <Switch
                                onChange={() => {
                                    setEntityEnable(!entityEnable);
                                    setDomainEnable(false);
                                }}
                                state={entityEnable}
                            />
                       </div>
                        <p className="mt1 mb1 font-bold">OR</p>
                       <div className='flex'>
                            <div className='flex-1'>
                                Enable Domain
                            </div>
                            <Switch
                                onChange={() => {
                                    setDomainEnable(!domainEnable);
                                    setEntityEnable(false);
                                }}
                                state={domainEnable}
                            />
                       </div>
                       {
                        entityEnable && <Input  allowSpecialCharacters={true} type="text" ref={ENTITY} placeholder="Enter Entity (optional)" label="Enter Entity(optional)"/>
                       }
                       {
                        domainEnable && 
                        <Input  allowSpecialCharacters={true} type="text" ref={DOMAIN} placeholder="Enter Domain (optional)" label="Enter Domain(optional)"/>

                       }
                    </>
                    }
                    <Input allowSpecialCharacters={true} type="text" ref={ID} placeholder="Enter Id" label="Name Id"/>
                    <Input allowSpecialCharacters={true} type="text" ref={EP} placeholder="Enter Endpoint" label="Endpoint"/>
                    <Input allowSpecialCharacters={true} type="text" ref={CERT} placeholder="Enter Cert" label="Certificate"/>
                    <Input allowSpecialCharacters={true} type="text" ref={PW} placeholder="Enter Password" label="Password"/>
                    <Button margin="mt4" onClick={()=>{
                        let mId = ID.current.value;
                        let ep = EP.current.value;
                        let crt = CERT.current.value;
                        let pw = PW.current.value;
                        let data = {
                            id:mId,ep,crt,pw
                        }
                        if(saas&& entityEnable) {
                            data.entity = ENTITY.current.value;
                        }
                        if(saas && domainEnable) {
                            data.domain = DOMAIN.current.value;
                        }
                        post(`/clients/saml/${id}`,data,(e,r)=>{
                            if(r){
                                TOAST.success("SAML configuration successful!!")
                                setModal(false)
                                load(id)
                            }
                        })
                    }} className="btn btn-black">
                        + Add Sso
                    </Button>
                </Modal>
            }
            {
                editModal && selectedEntity && <Modal title="Edit Sso Config" description="Edit sso configuration" onClose={()=>{setEditModal(false)}}>
                    <Input allowSpecialCharacters={true} type="text" defaultValue={selectedEntity.id} ref={ID} placeholder="Enter Id" label="Name Id"/>
                    <Input allowSpecialCharacters={true} type="text" defaultValue={selectedEntity.endPoint} ref={EP} placeholder="Enter Endpoint" label="Endpoint"/>
                    <Input allowSpecialCharacters={true} type="text" defaultValue={selectedEntity.cert} ref={CERT} placeholder="Enter Cert" label="Certificate"/>
                    <Input allowSpecialCharacters={true} type="text" defaultValue={selectedEntity.password} ref={PW} placeholder="Enter Password" label="Password"/>
                    <Button margin="mt4" onClick={()=>{
                        let mId = ID.current.value;
                        let ep = EP.current.value;
                        let crt = CERT.current.value;
                        let pw = PW.current.value;
                        let data = {
                            id:mId,ep,crt,pw,
                            entity: selectedEntity.entity,
                            domain:selectedEntity.domain

                        }
                        post(`/clients/saml/${id}`,data,(e,r)=>{
                            if(r){
                                TOAST.success("SAML configuration updated successfully!!")
                                setEditModal(false)
                                load(id)
                            }
                        })
                    }} className="btn btn-black">
                        Update Sso
                    </Button>
                </Modal>
            }
            <div className="border rounded-md pd4 mt4">
                <h2 className="fw-bold">
                    Authentication Settings
                </h2>
                <p>
                    Enable authentication settings appears below.
                </p>
                {
                    config.enabled&&<div className="mt4">
                        <p className="text text-light">
                            Endpoint:
                        </p>
                        <p className="">
                            {config.endPoint}
                        </p>
                        <KeyValue title="Id" value={config.id} margin="mt1"/>
                        <KeyValue title="Cert" value={config.cert}/>
                    </div>
                }
                {
                    saas &&
                    Object.keys(ssoConfig).map(mapItemSso)
                }
                {
                    saas &&
                    Object.keys(entityConfig).map(mapItem)
                }
                <Button onClick={toggle.bind(this,id)} className="btn btn-black" margin="mt4 mr2" style={{width:300}}>
                    {
                        config.enabled ? "- Disable Authentication":"+ Enable Authentication"
                    }
                </Button>
                {saas && <Button onClick={() => {
                        setModal(true);
                    }} className="btn btn-black" margin="mt4" style={{width:300}}>
                        + Add Domain Authentication
                    </Button>}
            </div>
        </>
    )
}
